import { render, staticRenderFns } from "./MeasurementRooms.vue?vue&type=template&id=10279367&"
import script from "./MeasurementRooms.vue?vue&type=script&lang=js&"
export * from "./MeasurementRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports